/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Icon_Bar_Chart_3Inputs */



/**
* | output |
* | --- |
* | "Chart" |
*
* @param {Agent_Builder_Icon_Bar_Chart_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_icon_bar_chart_3 = /** @type {((inputs?: Agent_Builder_Icon_Bar_Chart_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Icon_Bar_Chart_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diagramm")
	return /** @type {LocalizedString} */ ("Chart")
});